module.exports = __webpack_public_path__ + "static/assets/da3126c6a70c4ef84192c33f99996354.mp3";